"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const WrapText = (props) => React.createElement("svg", { className: "lucide lucide-wrap-text", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M3 6h18M3 12h15a3 3 0 110 6h-4" }),
    React.createElement("path", { d: "M16 16l-2 2 2 2M3 18h7" }));
exports.default = WrapText;
